<template>
  <Popup ref="popup" :title="title">
    <div class="popup-content">
      <van-form @submit="onSubmit">
        <van-field
          v-model="name"
          name="name"
          label="名称"
          placeholder="名称"
          :rules="[{ required: true, message: '请填写名称' }]"
        />
        <van-field
          v-model="seq"
          name="seq"
          label="排序"
          placeholder="排序"
          :rules="[{ required: true, message: '请填写排序' }]"
        />
        <van-field name="groupChecked" label="产品" :rules="[{ required: true, message: '请选择产品' }]">
          <template #input>
            <van-checkbox-group v-model="groupChecked" direction="horizontal">
              <van-checkbox v-for="item in goodsList" :key="item.goodsId" :name="item.goodsId" shape="square">{{item.goodsName}}</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <div class="btn-container">
          <van-button block type="primary" :loading="loading" loading-text="请稍后..." :disabled="loading" native-type="submit">
            确认提交
          </van-button>
        </div>
      </van-form>
    </div>
  </Popup>
</template>

<script>
import { ref, reactive, toRefs } from 'vue'
export default {
  name: 'AddEditSalesDepartment', // 添加编辑销售部
  props: {
    title: {
      type: String
    },
    goodsList: {
      type: Array
    }
  },
  emits: ['submit-values'],
  setup (props, { emit }) {
    // popup
    const popup = ref(null)
    const showPopup = () => {
      popup.value.show = true
      state.groupChecked = []
      state.name = ''
      state.seq = ''
    }
    const hidePopup = () => {
      popup.value.show = false
    }

    // form
    const state = reactive({
      groupChecked: [],
      name: '',
      seq: ''
    })
    const loading = ref(false)
    const onSubmit = (values) => {
      const { groupChecked, name, seq } = values
      const goodList = groupChecked.map(item => ({ goodsId: item }))
      emit('submit-values', { name, seq, goodList })
    }
    return { popup, showPopup, hidePopup, onSubmit, loading, ...toRefs(state), state }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
</style>
